import React, { useState } from "react";
import { IFreshman } from "../../../../../models/student/freshman";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../../../../constants/routerUrl";

const BetaFreshman = (props: IFreshman) => {
  const { userInfo } = props;
  const navigate = useNavigate();
  const [isBannerVisible, setBannerVisible] = useState(true);

  const handleView = () => {
    navigate(ROUTER_URL.FRESHMAN_PROCESS);
  };

  const handleClose = () => {
    setBannerVisible(false);
  };

  if (!isBannerVisible) return null;

  return (
    <>
      <div
        className="card-wrap freshman-register"
        id="freshman-register"
        style={{ position: "relative" }}
      >
        <a onClick={handleView}>
          <img
            src="assets/images/freshman.jpg"
            alt="Freshman Banner"
            style={{ borderRadius: "20px" }}
          />
        </a>
        {userInfo?.isCourseStarted && (
          <button
            id="freshman-close"
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
          >
            <img src="assets/images/icon/close.svg" alt="" />
          </button>
        )}
      </div>
    </>
  );
};

export default BetaFreshman;
